import Page from 'layouts/Page'
import React from 'react'
import PageWrapper from '../../../PageWrapper'
import { ApplicationGridContainer } from '../components/ApplicationGridContainer'
import { ApplicationQueueUsRestrictedGate } from '../components/ApplicationQueueUsRestrictedGate'
import { useBenefitQueues } from '../hooks/useBenefitQueues'
import { Button } from '@sureco/design-system'
import { Link } from 'react-router'

export const ApplicationQueueGrid = () => {
  return (
    <PageWrapper>
      <Page
        title="Application Queues"
        action={
          <Link to="/application-queue/performance-dashboard">
            <Button type="outline">Performance Dashboard</Button>
          </Link>
        }
      >
        <ApplicationQueueUsRestrictedGate>
          <ApplicationQueueGridContent />
        </ApplicationQueueUsRestrictedGate>
      </Page>
    </PageWrapper>
  )
}

function ApplicationQueueGridContent() {
  const { assignmentQueues: benefitQueues } = useBenefitQueues()
  return <ApplicationGridContainer benefitQueues={benefitQueues} />
}
